import { render, staticRenderFns } from "./InspectionRoutePoint.vue?vue&type=template&id=61b7a342&scoped=true"
import script from "./InspectionRoutePoint.vue?vue&type=script&lang=js"
export * from "./InspectionRoutePoint.vue?vue&type=script&lang=js"
import style0 from "./InspectionRoutePoint.vue?vue&type=style&index=0&id=61b7a342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61b7a342",
  null
  
)

export default component.exports